import React from "react";
import { connect } from "react-redux";
import { setQuoteName } from "../redux/actions";
import { isQuoteNameEmpty } from "../redux/selectors";
import { Form, Row, Col } from "react-bootstrap";

function QuoteName(props) {
  return (
    <Form.Group as={Row} controlId="quote_name">
      <Form.Label sm={2} column>
        Quote Name
      </Form.Label>

      <Col sm={4}>
        <Form.Control
          isInvalid={props.isQuoteNameEmpty}
          type="text"
          placeholder="New Quote"
          value={props.name}
          onChange={e => props.setQuoteName(e.target.value)}
        />
      </Col>
    </Form.Group>
  );
}

export default connect(
  state => ({
    name: state.quote.name,
    isQuoteNameEmpty: isQuoteNameEmpty(state)
  }),
  { setQuoteName }
)(QuoteName);
